package amazon.lastmile.inject

import app.nestbridge.feature.invitations.presentation.ShowInvitationQRCodePresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ShowInvitationQRCodePresenterFactory::class)
public interface AppNestbridgeFeatureInvitationsPresentationShowInvitationQRCodePresenterFactory {
  @Provides
  @IntoSet
  public fun provideShowInvitationQRCodePresenterFactoryFactoryMultibinding(showInvitationQRCodePresenterFactory: ShowInvitationQRCodePresenterFactory): Presenter.Factory = showInvitationQRCodePresenterFactory
}
